module.exports = __webpack_public_path__ + "media/images/flags/ga-b86e403f8c14d228deb0475a788e8e64.svg";